import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface RafScoreListResponse {
  IPA: string,
  Provider: string,
  ProviderKeyId: string
}

export interface RafScoreDetailsResponse {
  DOB: string,
  Gender: string,
  HealthPlan: string,
  IPA: string,
  MemberID: string,
  MemberName: string,
  Option: string,
  PrevRAFScore: null | string,
  PrevRAFScoreDate: null | string,
  RAFScore: string,
  RAFScoreDate: string
}

export const getRafScoreDetail = (providerKeyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_RAF_SCORE_REQUEST });

  return api.eligibility.rafScore.get(providerKeyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_RAF_SCORE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_RAF_SCORE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getRafScoreList = (userModel: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_RAF_SCORE_LIST_REQUEST });

  return api.eligibility.rafScore.getList(userModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_RAF_SCORE_LIST_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_RAF_SCORE_LIST_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getFile = (providerKeyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_RAF_SCORE_FILE_REQUEST });

  return api.eligibility.rafScore.getFile(providerKeyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_RAF_SCORE_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_RAF_SCORE_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getHistoricalRafScore = (provId: string, companyId: string, userId: string, measureYear: number, vendorId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_RAF_SCORE_FILE_REQUEST });

  return api.eligibility.rafScore.getHistoricalRafScore(provId, companyId, userId, measureYear, vendorId)
    .then((res: any) => {

      dispatch({
        type: types.GET_RAF_SCORE_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_RAF_SCORE_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
  };
